<template>
  <div class="content" :style="navbarWithName ? 'margin-left: 150px !important; margin-right: auto !important;' : ''"> <!--note: mt,mb,ml,mr(margin) jangan diubah-->
    <v-breadcrumbs :items="page" class="ml-2 mt-0 pt-0"></v-breadcrumbs>
      <h3 class="ml-8 my-4">{{  this.$store.state.title }}</h3>
      <v-row class="ma-6">
        <v-col cols="12" sm="6" md="3">
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
            >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="startdate"
                label="Start Date"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                >
              </v-text-field>
            </template>
            <v-date-picker v-model="startdate" no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="menu = false">
                Cancel
              </v-btn>
              <v-btn text color="primary" @click="$refs.menu.save(date)">
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>
    <v-spacer></v-spacer>
    <v-col cols="12" sm="6" md="3">
      <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="enddate"
            label="End Date"
            prepend-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
          >
          </v-text-field>
        </template>
        <v-date-picker
          v-model="enddate"
          no-title
          scrollable
          >
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            @click="menu2 = false"
            >
            Cancel
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="$refs.menu2.save(date)"
            >
            OK
          </v-btn>
        </v-date-picker>
      </v-menu>
    </v-col>
    
    <v-col  cols="12" sm="6" md="3">
        <v-btn
          dense
          color="#439EDF"
          dark
          rounded
          @click="search()"
        > search
          <v-icon class="ml-2">mdi-magnify</v-icon>
        </v-btn>
    </v-col>
    <v-col
      cols="12"
      sm="6"
      md="3"
      >
    </v-col>
    <v-col
      cols="12"
      sm="6"
      md="3"
      >
    </v-col>
    <v-spacer></v-spacer>
  </v-row>
    <v-data-table :headers="headers" :items="table" sort-by="Username" class="table-user ml-6 mr-6 rounded-lg"
    
    :loading="loadtable"
    loading-text="Loading data..."
    :pagination.sync="pagination" 
    :server-items-length="totalNumberOfItems" 
    :footer-props="{
      'items-per-page-options': listSize
    }"
    @update:options="paginate"
    >
    <template v-slot:[`item.actions`]="{ item }">
      <v-icon class="mx-2" small @click="editItem(item)">
        mdi-pencil
      </v-icon>
      <v-icon class="mx-2" small @click="deleteItem(item)">
        mdi-delete
      </v-icon>
    </template>

    <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">
        Reset
      </v-btn>
    </template>
  </v-data-table>
        <Notification  ref="alert"></Notification>
      </div>
</template>

<script>
import axios from "axios";
// import decode from 'jwt-decode'
// import jwt from 'vue-jwt-decode'
import Notification from  '@/components/Notification';
import { decryptionData } from '@/components/utils/utils.js';
import { mapGetters } from 'vuex';
  export default {
    components: {
      Notification: Notification
    },
    data: () => ({
      rolename: ['ADMIN', 'USER', 'REVIEWER'],
      userstatus: ['non active', 'active', 'disabled'],
      online: ['true', 'false'],
      startdate: new Date().toISOString().substr(0, 10),
      enddate: new Date().toISOString().substr(0, 10),
      menu: false,
      menu2: false,
      dialogDelete: false,
      decodedToken: null,
      headers: [
        { text: 'Action Date', value: 'TIMESTAMP' },
        { text: 'Username', value: 'USERNAME' },
        { text: 'IP', value: 'IP' },
        { text: 'Action', value: 'ACTION' },
        { text: 'Note', value: 'NOTE' },
      ],
      table: [],
      // pagenation 
      loadtable: true,
      totalNumberOfItems: 10,
      listSize: [10, 25, 50, 100],
      pagination:
        {
          limit: 10,
          page:  0,
        },
    // end pagenation 
      editedIndex: -1,
      editedItem: {
      },
      defaultItem: {
      },
    }),
    computed: {

      page() {
        return this.$store.state.breadcrumbs
      },
      ...mapGetters(['navbarWithName']), // Accessing navbarWithName from Vuex
      formTitle () {
        return this.editedIndex === -1 ? 'New User' : 'Edit User'
      },
    },
    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },
    created () {
      this.initialize()
    },
    methods: {
      
      search () {
        this.pagination.page = 0;
        this.initialize() 
      },
      paginate (val)
      {
        this.pagination.limit =val.itemsPerPage
        this.pagination.page =val.page-1
        this.initialize() 
      },
      initialize () {
        this.loadtable = true;
        axios.get("log-activity?page_v=" +  this.pagination.page + "&limit_v=" +  this.pagination.limit+ "&startdate=" + this.startdate+ "&enddate=" +  this.enddate,
          { headers:{'auth-token':localStorage.getItem('token_app')}},
          {dataType: 'json'}
          ).then((response) => {
            // console.log(response.data.token);
          //  let decodedToken  =  jwt.decode(localStorage.getItem('token_app'))
          
          const data = decryptionData(response.data.token);
          this.totalNumberOfItems =data.totalRows
            this.table =  data.result;
            // end loading 
            setTimeout(() =>{
              this.loadtable = false
            },1000)
          })
          .catch((e) => {
              switch (e.response.status) {
                 
                    // case 404:
                    //       this.$refs.alert.error_login(404);
                    //     break;
                    // case 403:
                    //       this.$refs.alert.error_login(403);
                    //     break;
                    default:
                        console.log('some other error');  // end up here all the time
                        break;
                  }
          this.errors=e.response.data.msg;
        });
        // this.table = [
        //   {
        //     actiondate: '2022-04-19 21:26:00',
        // username: 'kbi',
        // ip: '192.168.31.170',
        // action: 'Access Set BO Doc Manager',
        // note: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/100.0.4896.127 Safari/537.36 Edg/100.0.1185.44',
        //   },
        //   {
        //     actiondate: '2022-04-19 21:26:00',
        // username: 'kbi',
        // ip: '192.168.31.170',
        // action: 'Access Set BO Doc Manager',
        // note: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/100.0.4896.127 Safari/537.36 Edg/100.0.1185.44',
        //   },
        //   {
        //     actiondate: '2022-04-19 21:26:00',
        // username: 'kbi',
        // ip: '192.168.31.170',
        // action: 'Access Set BO Doc Manager',
        // note: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/100.0.4896.127 Safari/537.36 Edg/100.0.1185.44',
        //   },
        // ]
      },
      editItem (item) {
        this.editedIndex = this.table.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },
      deleteItem (item) {
        this.editedIndex = this.table.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },
      deleteItemConfirm () {
        this.table.splice(this.editedIndex, 1)
        this.closeDelete()
      },
      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      save () {
        if (this.editedIndex > -1) {
          Object.assign(this.table[this.editedIndex], this.editedItem)
        } else {
          this.table.push(this.editedItem)
        }
        this.close()
      },
    },
  }
</script>